import React, { useEffect, useRef, useState } from "react";
import homeImage from "../../src/assets/Home.png";
import styles from "./HomeSection.module.css";
let hasShownHomePopup = false;

// The id of the "Choose Your Assessment" section (the mock-test cards grid)
// that lives elsewhere on the Home page. Update this if that section's id
// is different in your markup.
const ASSESSMENT_SECTION_ID = "choose-assessment";

function HomeSection({ onStartAssessment, onLearnMore }) {
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const buttonsRef = useRef(null);

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (!hasShownHomePopup) {
      setShowPopup(true);
      hasShownHomePopup = true;
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      titleRef.current?.classList.add(styles.visible);
    }, 200);

    setTimeout(() => {
      subtitleRef.current?.classList.add(styles.visible);
    }, 500);

    setTimeout(() => {
      buttonsRef.current?.classList.add(styles.visible);
    }, 800);
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Scrolls the page down to the "Choose Your Assessment" section. Still
  // calls the onStartAssessment prop first (in case the parent uses it for
  // anything else, e.g. analytics or closing a modal), then falls back to
  // scrolling by id so this works even if the parent doesn't implement
  // the scroll itself.
  const handleStartAssessment = () => {
    onStartAssessment?.();

    const target = document.getElementById(ASSESSMENT_SECTION_ID);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      {/* ================= PREMIUM POPUP ================= */}
      {showPopup && (
        <div style={overlayStyle}>
          <div style={modalStyle}>
            {/* glow */}
            <div style={topGlow}></div>

            <div style={iconWrapper}>
              <div style={iconCircle}>🎓</div>
            </div>

            <span style={tagStyle}>
              Student Platform
            </span>

            <h2 style={headingStyle}>
              Welcome to Your
              <br />
              Exam Preparation Hub
            </h2>

            <p style={descStyle}>
              This platform is completely
              non-commercial and built to help
              students prepare for
              <strong>
                {" "}IELTS, TOEFL, GRE, CAT, GMAT,
                MAT, and PGCET{" "}
              </strong>
              with realistic mock test
              experiences and guided learning.
            </p>

            <div style={dividerStyle}></div>

            <button
              onClick={handleClosePopup}
              style={buttonStyle}
            >
              Continue Learning →
            </button>
          </div>
        </div>
      )}

      {/* ================= HERO ================= */}
     {/* ================= HERO ================= */}
<section className={styles.heroSection}>
  <div className={styles.cyberGrid}></div>

  <div className={styles.ambientGlow}></div>

  <div className={styles.heroWrapper}>
    
    {/* LEFT CONTENT */}
    <div className={styles.heroContent}>
      <h1
        ref={titleRef}
        className={styles.heroTitle}
      >
        <span className={styles.titleLine}>
          MASTER YOUR
        </span>

        <span className={styles.titleHighlight}>
          IELTS, TOEFL, GRE
        </span>

        <span className={styles.titleLine}>
          & MORE
        </span>

        <span className={styles.titleHighlight}>
          ENTRANCE MOCK TESTS
        </span>

        <span className={styles.titleFree}>
          For FREE
        </span>
      </h1>

      <p
        ref={subtitleRef}
        className={styles.heroSubtitle}
      >
        Take realistic IELTS, TOEFL, GRE,
        CAT, GMAT, MAT, and PGCET mock
        tests designed to simulate the
        actual exam experience and boost
        your confidence.
      </p>

      <div
        ref={buttonsRef}
        className={styles.heroActions}
      >
        <button
          className={styles.heroCta}
          onClick={handleStartAssessment}
        >
          <span className={styles.btnText}>
            Start Your Assessment
          </span>

          <span className={styles.arrowIcon}>
            →
          </span>
        </button>

        <button
          className={styles.heroSecondary}
          onClick={onLearnMore}
        >
          <span>Learn More</span>

          <span className={styles.playIcon}>
            ▶
          </span>
        </button>
      </div>
    </div>

    {/* RIGHT IMAGE */}
    <div className={styles.heroImageContainer}>
      <img
        src={homeImage}
        alt="TestX"
        className={styles.heroImage}
      />

    
    </div>
  </div>
</section>
    </>
  );
}

export default HomeSection;

/* ================= PREMIUM POPUP STYLES ================= */
/* Unified around the site's #10b981 green + a near-black surface, instead
   of the previous mixed green/blue gradient. */

const ACCENT = "#10b981";
const ACCENT_DARK = "#0ea371";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(3, 7, 18, 0.72)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
  padding: "1rem",
};

const modalStyle = {
  position: "relative",
  overflow: "hidden",
  background: "linear-gradient(145deg, #0b1220, #0f172a)",
  border: "1px solid rgba(16, 185, 129, 0.18)",
  padding: "2.7rem 2.3rem",
  borderRadius: "24px",
  maxWidth: "480px",
  width: "100%",
  textAlign: "center",
  color: "#ffffff",
  fontFamily:
    '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  boxShadow: "0 30px 80px rgba(0,0,0,0.5)",
};

const topGlow = {
  position: "absolute",
  top: "-120px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "260px",
  height: "260px",
  background: `radial-gradient(circle, ${ACCENT}33, transparent 70%)`,
};

const iconWrapper = {
  display: "flex",
  justifyContent: "center",
  marginBottom: "1rem",
};

const iconCircle = {
  width: "72px",
  height: "72px",
  borderRadius: "50%",
  background: `linear-gradient(135deg, ${ACCENT}, ${ACCENT_DARK})`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "2rem",
  boxShadow: `0 10px 30px ${ACCENT}59`,
};

const tagStyle = {
  display: "inline-block",
  padding: "0.4rem 0.9rem",
  borderRadius: "999px",
  background: "rgba(16, 185, 129, 0.12)",
  border: `1px solid ${ACCENT}40`,
  color: ACCENT,
  fontSize: "0.8rem",
  fontWeight: "700",
  marginBottom: "1.2rem",
  letterSpacing: "0.5px",
};

const headingStyle = {
  fontSize: "1.9rem",
  lineHeight: "1.28",
  fontWeight: "800",
  letterSpacing: "-0.3px",
  marginBottom: "1rem",
  color: "#f8fafc",
};

const descStyle = {
  fontSize: "0.98rem",
  lineHeight: "1.75",
  color: "rgba(226, 232, 240, 0.72)",
  marginBottom: "1.7rem",
};

const dividerStyle = {
  width: "100%",
  height: "1px",
  background:
    "linear-gradient(to right, transparent, rgba(255,255,255,0.14), transparent)",
  marginBottom: "1.8rem",
};

const buttonStyle = {
  width: "100%",
  background: ACCENT,
  border: "none",
  padding: "0.95rem 1.4rem",
  borderRadius: "12px",
  cursor: "pointer",
  fontWeight: "700",
  fontSize: "1rem",
  fontFamily: "inherit",
  color: "#04120c",
  transition: "background 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease",
  boxShadow: `0 12px 30px ${ACCENT}40`,
};